import { Controller } from "@hotwired/stimulus"

// Falls die zusätzliche Frage geändert wurde + Umfrage begonnen => Bestätigungsdialog
export default class extends Controller {
  static targets = ["dialog"]
  static values = { startedCount: Number, discardUrl: String }

  connect() {
    this.initialSnapshot = this.snapshot()
    this.confirmed = false
  }

  confirm(event) {
    if (this.confirmed || this.startedCountValue === 0 || !this.hasDialogTarget) return
    if (this.snapshot() === this.initialSnapshot) return

    event.preventDefault()
    this.dialogTarget.showModal()
  }

  save() {
    this.confirmed = true
    this.dialogTarget.close()
    this.element.requestSubmit()
  }

  discard() {
    window.location.href = this.discardUrlValue
  }

  // ESC Taste: wie "Alle Änderungen verwerfen"
  cancel(event) {
    event.preventDefault()
    this.discard()
  }

  // Aktuelle Werte aller custom_question_*-Felder als vergleichbarer String.
  // Zeilenumbrüche werden normalisiert, damit \r\n vs. \n keinen Fehlalarm auslöst.
  snapshot() {
    const entries = [...new FormData(this.element).entries()]
      .filter(([name]) => name.includes("[custom_question_"))
      .map(([name, value]) => [name, String(value).replace(/\r\n/g, "\n").trim()])
      .filter(([, value]) => value !== "")   // leere Zeilen ignorieren
    return JSON.stringify(entries)
  }

  // Enter in Eingabefeldern soll das Formular nie abschicken
  preventEnterSubmit(event) {
    if (event.key !== "Enter") return
    if (event.target.matches("textarea, button, [type=submit]")) return
    event.preventDefault()
  }
}